<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('editBat.title') }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section v-if="parution">
      <informations
        :parution="parution"
        :produit="produit"
        click-code/>
      <div class="level mgv-20px">
        <div class="level-left">
          <div class="columns">
            <div class="column is-narrow">
              <selecteur-action
                :options="actions"
                :placeholder='$t("general.placeHolder.groupedAction")'
                :elementsSelectionnes="false"
                titleButton="general.button.apply">
              </selecteur-action>
            </div>
            <form
              @submit.prevent="generateColumns"
              class="column is-5 pdr-0">
              <b-input
                v-model="search"
                :placeholder="$t('general.autocomplete.search')"
                type="search" icon="magnify">
              </b-input>
            </form>
          </div>
        </div>
      </div>
      <app-container
        :drag-begin-delay="500"
        drag-handle-selector=".column-drag-handle"
        orientation="horizontal"
        lock-axis="y"
        v-if="columns.length > 0"
        class="bat-draggable">
        <app-draggable
          v-for="column in columns"
          :key="column.key"
          class="bat-column">
          <div class="card">
            <div class="card-header pd-10px">
              <span><b-icon icon="circle" :type="getTypeIcon(column.key)"></b-icon></span>
              <p class="has-text-weight-bold mgl-5px">{{$t(column.libelle)}}</p>
              <span class="mgl-5px">({{ getLigneOfChildren(column) }})</span>
            </div>
            <div class="min-height-full-530px card-content
            is-paddingless has-background-background">
              <app-container
                :get-child-payload="getPayload(column.key)"
                :drop-placeholder="{
                  className: 'drop-preview',
                  animationDuration: '150',
                  showOnTop: true,
                }"
                @drop="(e) => onCardDrop(column.key, e)"
                drag-class="card-ghost"
                drop-class="card-ghost-drop"
                group-name="col">
                <app-draggable v-for="ligne in column.lignes" :key="ligne.id">
                  <bat-card
                    @refresh="initData()"
                    @moveCard="moveBatCard"
                    :etat-bat="column.key"
                    :ligne="ligne"
                    :parution="parution"
                    :column-index="column.index"
                    :columns-length="columns.length"
                    :ajouterBATdansMail="ajouterBATdansMail"
                  />
                </app-draggable>
              </app-container>
            </div>
          </div>
        </app-draggable>
      </app-container>
    </section>
    <b-modal
      v-model="popUpUploadLigne" has-modal-card class="modal"
      @close="revertLigneCommande">
      <pop-up-upload-ligne
        :ligne="currentDataCardLigne.ligne"
        :etatBat="currentDataCardLigne.columnEndId"
        @is-upload="initData">
      </pop-up-upload-ligne>
    </b-modal>
  </div>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd';
import cloneDeep from 'lodash/cloneDeep';
import { getWithDispoAsync } from '@/api/presse/parution';
import { get as getPresse } from '@/api/produit/produitPresse';
import { updateLogistiquePresse } from '@/api/ligneCommande';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import { applyDrag } from '@/services/general/draggable';
import {
  ETAT_BAT,
  DEMANDE_VISUEL,
  ENVOIE_BAT,
  ATTENTE_RETOUR_BAT,
  BAT_SIGNE,
  TRANSMI_PAO,
  VALIDATION_VRP,
} from '@/configuration/presse/produitPresse/produitPresseConf';
import AppBreadcrumb from '@/components/general/breadcrumb';
import SelecteurAction from '@/components/general/selecteurAction';
import Informations from '@/components/presse/parution/detail/informations';
import BatCard from '@/components/presse/parution/bat/batCard';
import PopUpUploadLigne from '@/components/presse/parution/bat/p_updateLigneCommandePresse';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    appContainer: Container,
    appDraggable: Draggable,
    AppBreadcrumb,
    SelecteurAction,
    Informations,
    BatCard,
    PopUpUploadLigne,
  },
  data() {
    return {
      columns: [],
      parution: null,
      produit: null,
      search: '',
      actions: [],
      popUpUploadLigne: false,
      currentDataCardLigne: {
        ligne: {},
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('editBat.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('editBat.breadcrumb.liste'), route: { name: 'l.presse.parution' }, isActive: false },
        { title: this.$i18n.t('editBat.breadcrumb.edit'), route: { name: '' }, isActive: true },
      ];
    },
    ajouterBATdansMail() {
      return this.parametresInterne([PARAMETRES_INTERNE_KEYS.ajouterBATdansMail.key]) === 'true';
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    inProgress() {
      inProgress(this.$i18n);
    },
    getLigneOfChildren(column) {
      return column.lignes.length;
    },
    getTypeIcon(key) {
      if (key === DEMANDE_VISUEL) return 'is-attenteVisuel';
      if (key === TRANSMI_PAO) return 'is-colorEnvoieBat';
      if (key === VALIDATION_VRP) return 'is-colorEnvoieBat';
      if (key === ENVOIE_BAT) return 'is-colorEnvoieBat';
      if (key === ATTENTE_RETOUR_BAT) return 'is-colorAttenteRetourBat';
      return 'is-colorBatSigne';
    },
    async initData() {
      const parution = (await getWithDispoAsync(this.$route.params.parutionId)).data.result;
      parution.lignesCommandes.forEach(ligne => {
        if (ligne.lignePresse.dateBatDemande) {
          ligne.lignePresse.dateBatDemande = new Date(ligne.lignePresse.dateBatDemande);
        }
        if (ligne.lignePresse.dateDemandeVisuel) {
          ligne.lignePresse.dateDemandeVisuel = new Date(ligne.lignePresse.dateDemandeVisuel);
        }
        if (ligne.lignePresse.dateLivraison) {
          ligne.lignePresse.dateLivraison = new Date(ligne.lignePresse.dateLivraison);
        }
        if (ligne.lignePresse.dateTransmisPAO) {
          ligne.lignePresse.dateTransmisPAO = new Date(ligne.lignePresse.dateTransmisPAO);
        }
        if (ligne.lignePresse.dateValidationVRP) {
          ligne.lignePresse.dateValidationVRP = new Date(ligne.lignePresse.dateValidationVRP);
        }
        if (ligne.lignePresse.dateEnvoiBat) {
          ligne.lignePresse.dateEnvoiBat = new Date(ligne.lignePresse.dateEnvoiBat);
        }
        if (ligne.lignePresse.dateValidationVRP) {
          ligne.lignePresse.dateValidationVRP = new Date(ligne.lignePresse.dateValidationVRP);
        }
      });
      this.parution = parution;
      this.generateColumns();
      this.popUpUploadLigne = false;
    },
    generateColumns() {
      const columns = cloneDeep(ETAT_BAT).map((c, i) => ({
        ...c, id: c.key, lignes: [], index: i,
      }));
      if (!this.parution?.lignesCommandes) {
        this.columns = columns;
        return;
      }
      columns.forEach(c => {
        if (c.key === DEMANDE_VISUEL) {
          c.lignes = this.parution.lignesCommandes
            .filter(ligne => [DEMANDE_VISUEL, null].includes(ligne.lignePresse.etatBat))
            .filter(ligne => {
              return ligne.lignePresse.libelle.toLowerCase().includes(this.search.toLowerCase());
            });
        } else {
          c.lignes = this.parution.lignesCommandes
            .filter(ligne => ligne.lignePresse.etatBat === c.key)
            .filter(ligne => {
              return ligne.lignePresse.libelle.toLowerCase().includes(this.search.toLowerCase());
            });
        }
      });
      this.columns = columns;
    },
    getPayload(columnId) {
      return index => {
        return this.columns.filter(c => c.id === columnId)[0].lignes[index];
      };
    },
    onCardDrop(columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const columns = cloneDeep(this.columns);
        const column = columns.filter(p => p.id === columnId)[0];
        const columnIndex = columns.indexOf(column);
        const newColumn = cloneDeep(column);
        newColumn.lignes = applyDrag(newColumn.lignes, dropResult);
        columns.splice(columnIndex, 1, newColumn);
        this.columns = columns;
        if (dropResult.payload.lignePresse.etatBat !== columnId) {
          this.updateLigneCommande(dropResult.payload);
        }
      }
    },
    moveBatCard(ligne, columnIndex) {
      const columns = cloneDeep(this.columns);
      const oldColumnIndex = columns.findIndex(c => c.id === ligne.lignePresse.etatBat);
      if (oldColumnIndex !== -1) {
        const oldColumn = columns[oldColumnIndex];
        const ligneIndex = oldColumn.lignes.findIndex(l => l.id === ligne.id);
        oldColumn.lignes.splice(ligneIndex, 1);
        columns.splice(oldColumnIndex, 1, oldColumn);
      }
      const newColumn = columns[columnIndex];
      newColumn.lignes.unshift(ligne);
      columns.splice(columnIndex, 1, newColumn);
      this.columns = columns;
      this.updateLigneCommande(ligne);
    },
    async updateLigneCommande(ligne) {
      const column = this.columns.find(c => c.lignes
        .map(l => l.lignePresse.id)
        .includes(ligne.lignePresse.id));
      if (column && column.key !== ligne.lignePresse.etatBat) {
        if (column.key !== BAT_SIGNE) {
          await updateLogistiquePresse({
            ligneCommandeIds: [ligne.lignePresse.id],
            etatBat: column.key,
            accordTelephonique: false,
            commentaireAccord: null,
            dateAccord: null,
          });
          await this.initData();
        } else {
          this.currentDataCardLigne = {
            columnStartId: ligne.lignePresse.etatBat,
            columnEndId: column.key,
            ligne,
          };
          this.popUpUploadLigne = true;
        }
      }
    },
    revertLigneCommande() {
      const { columnStartId, columnEndId, ligne } = this.currentDataCardLigne;
      const columns = cloneDeep(this.columns);
      columns.forEach(c => {
        if (c.key === columnStartId) c.lignes.push(ligne);
        if (c.key === columnEndId) {
          const index = c.lignes
            .findIndex(l => l.lignePresse.id === ligne.lignePresse.id);
          if (index !== -1) c.lignes.splice(index, 1);
        }
      });
      this.columns = columns;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.ajouterBATdansMail.key]);
      await this.initData();
      if (this.parution.produitId) {
        this.produit = (await getPresse(this.parution.produitId)).data.result;
      }
      this.setInformationPage(this.$t('pagePresse.bat.modification', { code: this.parution.nomParution }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
